import React from 'react';
import { motion } from 'framer-motion';
import { Skeleton } from 'antd';
import { 
  GiNecklace, GiLipstick, GiEarrings, GiPerfumeBottle, GiMagicPotion 
} from 'react-icons/gi';
import './CategorySelector.css';

// Configuración actualizada con degradado elegante para botones
const predefinedCategories = [
  { 
    name: "Labiales", 
    id: "labiales", 
    icon: <GiLipstick />, 
    gradient: "linear-gradient(135deg, #FF0080 0%, #7928CA 100%)",
    shadow: "0 10px 20px rgba(255, 0, 128, 0.3)"
  },
  { 
    name: "Aretes", 
    id: "aretes", 
    icon: <GiEarrings />, 
    gradient: "linear-gradient(135deg, #FF0080 0%, #7928CA 100%)",
    shadow: "0 10px 20px rgba(255, 0, 128, 0.3)"
  },
  { 
    name: "Collares", 
    id: "collares", 
    icon: <GiNecklace />, 
    gradient: "linear-gradient(135deg, #FF0080 0%, #7928CA 100%)",
    shadow: "0 10px 20px rgba(255, 0, 128, 0.3)"
  },
  { 
    name: "Cremas", 
    id: "cremas", 
    icon: <GiMagicPotion />, 
    gradient: "linear-gradient(135deg, #FF0080 0%, #7928CA 100%)",
    shadow: "0 10px 20px rgba(255, 0, 128, 0.3)"
  },
  { 
    name: "Perfumes", 
    id: "perfumes", 
    icon: <GiPerfumeBottle />, 
    gradient: "linear-gradient(135deg, #FF0080 0%, #7928CA 100%)",
    shadow: "0 10px 20px rgba(255, 0, 128, 0.3)"
  }
];

const CategorySelector = ({ selected, onSelect, loading = false }) => {
  const handleCategoryClick = (categoryId) => {
    if (onSelect) {
      // Mapear los IDs del CategorySelector a las categorías reales
      const categoryMapping = {
        'labiales': 'Labiales',
        'aretes': 'Aretes', 
        'collares': 'Collares',
        'cremas': 'Cremas',
        'perfumes': 'Perfumes'
      };

      const categoryName = categoryMapping[categoryId];
      
      if (categoryName) {
        // Buscar la sección de la categoría y hacer scroll
        const categorySection = document.getElementById(`category-${categoryName.toLowerCase()}`);
        if (categorySection) {
          categorySection.scrollIntoView({ 
            behavior: 'smooth', 
            block: 'start' 
          });
        }
        
        // Llamar a onSelect con el categoryId
        onSelect(categoryId);
      }
    }
  };

  // Animaciones refinadas
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.06
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 15, scale: 0.9 },
    visible: {
      opacity: 1,
      y: 0,
      scale: 1,
      transition: { type: 'spring', stiffness: 350, damping: 20 }
    }
  };

  if (loading) {
    return (
      <div className="flutter-category-selector">
        <div className="category-scroll-container">
          {[1, 2, 3, 4, 5].map((i) => (
            <div key={i} className="category-btn skeleton-btn">
              <Skeleton.Button active shape="square" style={{ width: '100%', height: '100%', borderRadius: '16px' }} />
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="flutter-category-selector">
      <motion.div
        variants={containerVariants}
        initial="hidden"
        animate="visible"
        className="category-scroll-container"
      >
        {predefinedCategories.map((category) => (
          <motion.button
            key={category.id}
            variants={itemVariants}
            whileHover={{ scale: 1.05, y: -4 }}
            whileTap={{ scale: 0.95 }}
            onClick={() => handleCategoryClick(category.id)}
            className={`category-btn${selected === category.id ? ' selected' : ''}`}
            aria-label={category.name}
            style={{
              background: 'linear-gradient(135deg, #FF0080 0%, #7928CA 100%)',
              backgroundImage: 'linear-gradient(135deg, #FF0080 0%, #7928CA 100%)',
              boxShadow: '0 10px 25px rgba(255, 0, 128, 0.25), 0 6px 12px rgba(121, 40, 202, 0.2)'
            }}
          >
            <div className="btn-glass-effect"></div>
            <span className="icon">
              {category.icon}
            </span>
            <span className="category-label">
              {category.name}
            </span>
          </motion.button>
        ))}
      </motion.div>
    </div>
  );
};

export default CategorySelector;
